import { Injectable } from "@angular/core";
import { BaseApi } from "./baseService";
import { CBP3461 } from "../objects/documents/CBP3461";
import { RequestOptions, URLSearchParams } from "@angular/http";
import { BaseResponse } from "../objects/common/baseResponse";

@Injectable()
export class DocumentService extends BaseApi {

    public save<T>(document: T, type: 'CBP3461' | 'CBP7501'): Promise<any> {
        return this.post(new RequestOptions({
            url: `document/${type}`,
            body: document
        }));
    }

    public getDocuments<T>(orderId: number, type: 'CBP3461' | 'CBP7501', skip: number = 0, top:number = 10) : Promise<BaseResponse<Array<T>>>{
        let params = new URLSearchParams();

        params.append('top', top.toString());
        params.append('skip', skip.toString());

        return this.get(new RequestOptions({
            url: `document/list/${type}/${orderId}`,
            search: params
        }));
    }

    public getDocumentById<T>(id: string, type: 'CBP3461' | 'CBP7501') : Promise<BaseResponse<T>>{
        return this.get(new RequestOptions({
            url: `document/${type}/${id}`
        }));
    }

    public deleteDocumentById(id: string, type:'CBP3461' | 'CBP7501') : Promise<any>{
        return this.delete(new RequestOptions({
            url: `document/${type}/${id}`
        }));
    }
}


// WEBPACK FOOTER //
// ./app/services/documentService.ts